import { PROMPT_INSTRUCTION_TYPE } from 'src/data/generation';

export const INSIGHTS_STRUCTURE_INSTRUCTION_TYPES = [
  PROMPT_INSTRUCTION_TYPE.vocabulary,
  PROMPT_INSTRUCTION_TYPE.format,
];
